import axios from '@/axios'

export default {
  getSubKategori (options = {}) {
    return axios.get('/sub-kategori-sos', options)
  },
  getCategory(options = {}) {
  	return axios.get('/kategori-sos', options)
  }
}